module.exports = __webpack_public_path__ + "static/media/add1.3e1f326a.svg";